import { ReactNode } from "react";
import { LucideIcon } from "lucide-react";

interface PageHeaderProps {
  title: string;
  description?: string;
  icon?: LucideIcon;
  children?: ReactNode;
}

export function PageHeader({ title, description, icon: Icon, children }: PageHeaderProps) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
      <div className="min-w-0 flex-1">
        <h1 className="text-2xl font-bold text-gray-900 flex items-center">
          {Icon && <Icon className="h-8 w-8 mr-3 text-red-600" />}
          {title}
        </h1>
        {description && <p className="mt-1 text-sm text-gray-600">{description}</p>}
      </div>
      {children && <div className="mt-4 sm:mt-0 sm:ml-4">{children}</div>}
    </div>
  );
}
